module.exports = __webpack_public_path__ + "img/thumbnail_Nyala_f_normal.29b9a18b.png";